export default "__VITE_ASSET__yaO2T$8Q__"